export const createAnnouncement = /* GraphQL */ `
  mutation CreateAnnouncement(
    $input: CreateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    createAnnouncement(input: $input, condition: $condition) {
      id
      createdAt
      orgId
      group
      viewers
      title
      text
      status
      updatedAt
      owner
      __typename
    }
  }
`;

export const updateAnnouncement = /* GraphQL */ `
  mutation UpdateAnnouncement(
    $input: UpdateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    updateAnnouncement(input: $input, condition: $condition) {
      id
      createdAt
      orgId
      group
      viewers
      title
      text
      status
      updatedAt
      owner
      __typename
    }
  }
`;

export const deleteAnnouncement = /* GraphQL */ `
  mutation DeleteAnnouncement(
    $input: DeleteAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    deleteAnnouncement(input: $input, condition: $condition) {
      id
      createdAt
      orgId
      group
      viewers
      title
      text
      status
      updatedAt
      owner
      __typename
    }
  }
`;
